module.exports = __webpack_public_path__ + "img/ico-scan.51f39269.svg";